import { useMemo } from "react";

import { useGetFinancialPeriods } from "../../hooks/react-query/useFinancialsData";

export const useFinancialPeriodList = ({ locationId } = {}) => {
  const { data, isLoading, isSuccess } = useGetFinancialPeriods();

  const periods = useMemo(() => {
    if (!data) return [];
    return locationId
      ? data.filter((p) => p.locationId === Number(locationId))
      : data;
  }, [data, locationId]);

  return { periods, isLoading, isSuccess };
};
